import './footer.less'

import {Component, Icon, Image, action, classes} from '@codeurs/front'

import Button from '../layout/button'
import Link from 'views/layout/link'
import {LinkType} from 'types/types'
import OptinForm from 'forms/optinform'
import logo from 'assets/images/smeunited-logo.svg'
import m from 'mithril'
import {t} from 'store'

export default class Footer extends Component<{
	links?: {
		home: LinkType
		privacy?: LinkType
		terms?: LinkType
		cookie_declaration?: LinkType
	}
	footer_menu: Array<LinkType>
	social: {
		title?: string
		text?: string
		links: any
	}
	contact: {address; postal; city; phone; fax; email}
}> {
	form = new OptinForm()
	isCompleted = false
	errors = []

	getErrors(key: string) {
		return this.errors && this.errors[key]
	}

	scrollToTop = () => {
		const c = document.documentElement.scrollTop || document.body.scrollTop
		if (c > 0) {
			window.requestAnimationFrame(this.scrollToTop)
			window.scrollTo(0, c - c / 8)
		}
	}

	view() {
		return m('footer.footer', [
			m('.footer-top',
				m('.footer-top-container', [
					m('.footer-top-spacer'),
					this.viewContent()
				])
			),
			this.viewBottom()
		])
	}

	viewContent() {
		return m('.footer-content', [
			this.viewInfo(),
			this.viewFooterMenu(),
			this.viewSocial()
		])
	}

	viewInfo() {
		const {contact, links} = this.attrs
		return m('.footer-content-info', [
			m('a.footer-content-info-logo',
				action(links.home.url),
				m(Image, {
					class: 'footer-content-info-logo-img',
					src: logo,
					alt: 'SMEunited logo'
				})
			),
			m('.footer-content-info-address', [
				contact.address && m('', contact.address),
				m('.footer-content-info-address-flex', [
					contact.postal &&
						m('.footer-content-info-address-flex-postal', contact.postal + ' '),
					contact.city &&
						m('.footer-content-info-address-flex-city', contact.city)
				]),
				contact.phone && m('', 'Tel.: ' + contact.phone),
				contact.fax && m('', 'Fax.: ' + contact.fax)
			]),
			m('.footer-content-info-email', [
				contact.email &&
					m(Link,
						{
							...action(`mailto:${contact.email}`),
							...classes('footer-content-info-email')
						},
						contact.email
					)
			])
		])
	}

	viewFooterMenu() {
		const {footer_menu} = this.attrs
		return m('.footer-content-menu',
			footer_menu.map(item =>
				m('.footer-content-menu-item',
					m(Link,
						{
							class: 'footer-content-menu-item-link',
							mod: 'scaleonhover',
							...action(item.url)
						},
						m.trust(item.title)
					)
				)
			)
		)
	}

	viewSocial() {
		const {social} = this.attrs
		return m('.footer-content-news', [
			m('.footer-content-news-top', [
				m('.footer-content-news-top-title', social.title),
				this.viewSocialLinks()
			]),
			m('.footer-content-news-top-text', social.text),
			this.viewOptIn()
		])
	}

	viewOptIn() {
		if (this.isCompleted)
			return m('.footer-content-optin-thanks', t('footer.thanks'))

		return m('form.footer-content-optin',
			{
				onsubmit: () => {
					action.navigate('/subscribe?email=' + this.form.email)
					this.scrollToTop()
				}
			},
			[
				this.form.email({
					key: 'email',
					required: true,
					placeholder: t('contact.email'),
					className: 'footer-content-optin-email',
					errors: this.getErrors('email')
				}),
				m(Button,
					{
						type: 'submit',
						class: 'footer-content-optin-button',
						mod: 'round'
					},
					t('footer.subscribe')
				)
			]
		)
	}

	viewSocialLinks() {
		const {social} = this.attrs

		return m('.footer-content-news-top-links', [
			this.viewSocialLink('linkedin'),
			this.viewSocialLink('twitter'),
			this.viewSocialLink('bluesky'),
			this.viewSocialLink('facebook'),
			m(Link,
				{
					class: 'footer-content-news-top-links-link share',
					...action('mailto:?BODY=' + window.location.href),
					title: 'Share'
				},
				m(Icon, {icon: 'share'})
			)
		])
	}

	viewSocialLink(key: string) {
		const {social} = this.attrs
		if (!social.links[key].url) return null

		return m('a.footer-content-news-top-links-link',
			{
				href: social.links[key].url,
				target: social.links[key].target,
				title: social.links[key]?.description || social.links[key].title,
				class: key
			},
			m(Icon, {
				icon: key
			})
		)
	}

	viewBottom() {
		const {links} = this.attrs
		return m('.footer-bottom',
			m('p', [
				t('footer.copyright'),
				links.privacy && [
					m('span.footer-bottom-link-spacer', '|'),
					m('a.footer-bottom-link',
						{
							...action(links.privacy.url)
						},
						m.trust(links.privacy.title)
					),
					m('span.footer-bottom-link-spacer', '|'),
					m('a.footer-bottom-link',
						{
							...action(links.cookie_declaration.url)
						},
						m.trust(links.cookie_declaration.title)
					)
				]
			])
		)
	}
}
